<offcanvas-hoc
    [offcanvasTitle]="title"
    [offcanvasTitleIcon]="icon"
	(offcanvasDismissed)="onOffcanvasDismissed($event)">
    <fdx-cheat-sheet [onCheatSheetPage]="false"></fdx-cheat-sheet>
</offcanvas-hoc>
